import { useState } from "react";
import { Box, Typography } from "@mui/material";
import BszSectionCard from "../BszSectionCard";
import { useBszFinderContext } from "../../../context/bszContext";
import { useAppContext } from "../../../../../2_ksbHub/context/appContext";
import BszSubjectCategory from "./components/BszSubjectCategory";
import useTeacherSubjects from "./hooks/useTeacherSubjects";
import BszTeacherSearch from "./components/BszTeacherSearch";
import BszTeacherList from "./components/BszTeacherList";

/**
 * =========================================================
 * ✅ COMPONENT
 * =========================================================
 */
export default function BszWerHilftSection() {
  const { rooms, serverNow } = useBszFinderContext();
  const { isMobile } = useAppContext();

  const [query, setQuery] = useState("");
  const [selectedSubject, setSelectedSubject] = useState(null);

  /**
   * =========================================================
   * ✅ States
   * =========================================================
   */
  const { grouped, subjects, categorizedSubjects, teachersForSelected } =
    useTeacherSubjects(rooms, query, selectedSubject);

  /**
   * =========================================================
   * ✅ TIME HELPER
   * =========================================================
   */
  const getRemaining = (endTime) => {
    if (!endTime || !serverNow) return null;

    // console.log("Wer hilft?: endTime", endTime, " ServerNow: ", serverNow);
    return Math.floor(Math.max(0, endTime - serverNow) / 60000);
  };

  return (
    <BszSectionCard title="Wer hilft bei …?" defaultExpanded={false}>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        {/* ✅ SEARCH */}
        <BszTeacherSearch
          hasTeachers={subjects.length > 0}
          query={query}
          onChange={setQuery}
        />

        {/* ✅ SUBJECTS BY CATEGORY */}
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
          {Object.entries(categorizedSubjects).map(([category, subjects]) => (
            <BszSubjectCategory
              key={category}
              category={category}
              subjects={subjects}
              grouped={grouped}
              selectedSubject={selectedSubject}
              onSelectSubject={setSelectedSubject}
            />
          ))}
        </Box>

        {/* ✅ EMPTY */}
        {subjects.length === 0 && query && (
          <Typography sx={{ opacity: 0.6 }}>
            {isMobile ? "❌ Niemand da" : "❌ Keine Lehrperson anwesend"}
          </Typography>
        )}

        {/* ✅ TEACHER LIST */}
        {selectedSubject && (
          <BszTeacherList
            subject={selectedSubject}
            teachers={teachersForSelected}
            getRemaining={getRemaining}
          />
        )}
      </Box>
    </BszSectionCard>
  );
}
